import React from 'react'
import { ApolloQueryResult } from '@apollo/client'
import { OverallInformationForm } from './OverallInformationForm'
import { ReasonForSeekTreatmentForm } from './ReasonForSeekTreatmentForm'
import { MentalHealthTreatmentHistoryForm } from './MentalHealthTreatmentHistoryForm'
import { RiskAssessmentForm } from './RiskAssessmentForm'
import { BiopsychosocialEvaluationForm } from './BiopsychosocialEvaluationForm'
import { MentalStatusExaminationForm } from './MentalStatusExaminationForm'
import { DiagnosticSummaryForm } from './DiagnosticSummaryForm'
import { ConfirmationAndNextStepsForm } from './ConfirmationAndNextStepsForm'
import { GetIntakeNoteComprehensivePatientDataQuery } from './initialValues/getIntakeNoteComprehensivePatientData.generated'

type IntakeNoteComprehensiveFieldsProps = {
  refetch?: () => Promise<ApolloQueryResult<GetIntakeNoteComprehensivePatientDataQuery>>
  viewOnly?: boolean
}

export function IntakeNoteComprehensiveFields({ refetch, viewOnly }: IntakeNoteComprehensiveFieldsProps) {
  return (
    <>
      <OverallInformationForm />

      <ReasonForSeekTreatmentForm refetch={refetch} />

      <MentalHealthTreatmentHistoryForm />

      <RiskAssessmentForm />

      <BiopsychosocialEvaluationForm />

      <MentalStatusExaminationForm />

      <DiagnosticSummaryForm viewOnly={viewOnly} />

      <ConfirmationAndNextStepsForm />
    </>
  )
}
